<template>
  <div>
    <tableHeader
      :selectAll="true"
      ref="tableDown"
      :downShow="true"
      :chekTableNum="chekTableNum"
      :headerShow="false"
      @allCheck="toggleSelection(tableData,'true')"
      @cancelAllCheck="toggleSelection()"
    ></tableHeader>
    <el-table
      header-row-class-name="data-table-header-style"
      :data="tableData"
      style="width: 100%;margin-top:20px;"
      @selection-change="selectionChange"
      @row-click="tableRowClick"
    >
      <el-table-column type="selection" width="55"></el-table-column>
      <el-table-column type="index" label="序号" width="55"></el-table-column>
      <el-table-column prop="date" label="违规信息">
        <template slot-scope="scope">
          <div class="pointer aling_center">
            <img
              v-if="scope.row.platform_code"
              :src="require('@/assets/img/platform/pla_'+scope.row.platform_code+'.png')"
              alt
              class="edit_icon"
            />
            <span>{{scope.row.shop_name}}（{{scope.row.reportid}}）</span>
          </div>
          <el-link
            v-show="scope.row.reporturl"
            :underline="false"
            :href="scope.row.reporturl"
            type="primary"
            target="_blank"
          >{{scope.row.reporturl}}</el-link>
          <div>产品信息：嘻嘻嘻嘻</div>
          <div>举报时间: {{scope.row.createtime | fullTime}}</div>
        </template>
      </el-table-column>
      <el-table-column prop="name" label="处理状态/备注" width="250">
        <template slot-scope="scope">
          <!-- 异常举报-->
          <div class="deal_state_icon">
            <i
              :class="scope.row.status==10?'el-icon-error':'el-icon-success'"
              v-show="scope.row.status==10||scope.row.status==9"
            ></i>
            <img
              src="../../../assets/img/other/await_icon.png"
              alt
              class="await_icon"
              v-show="scope.row.status!=10&&scope.row.status!=9"
            />
            <span v-if='scope.row.status'>{{scope.row.status|getStatusNme}}</span>
          </div>
          <!-- 店铺已申诉-->
          <div v-show="scope.row.status==5">
            <div>申诉时间: {{scope.row.flowtime| fullTime}}</div>
            <div class="ellipsis">申诉理由:{{scope.row.reportexplain}}</div>
          </div>
          <!-- 已结案-->
          <div v-show="scope.row.status==9">
            <div>处理时间: {{scope.row.flowtime| fullTime}}</div>
            <div class="ellipsis">判罚结果：{{scope.row.reason}}（-{{scope.row.deduction}}）</div>
          </div>
          <!-- 异常举报-->
          <div v-show="scope.row.status==10">
            <div>处理时间: {{scope.row.flowtime| fullTime}}</div>
            <div class="ellipsis">驳回说明：{{scope.row.reportexplain}}</div>
          </div>
        </template>
      </el-table-column>
    </el-table>
    <Pagination
      @onChange="changePage"
      v-if="tableData.length > 0"
      class="pagination"
      :total="tableData.totalPage"
      :pagination="pagination"
      :pagesizes="pagesizes"
      style="text-align:right;margin:20px 0;"
    />
    <rightInfo ref="showInfo"></rightInfo>
  </div>
</template>
<script>
import tableHeader from "../common/tableHeader"; //表头
import { getLoginType } from "@/libs/until";
import { mapGetters, mapActions, mapState, mapMutations } from "vuex";
import Pagination from "components/pagination/pagination";
import rightInfo from "./rightInfo";
export default {
  data() {
    return {
      tableData: [
        {
          flowtime: "2016-05-02",
          reportexplain: "54444",
          createtime: "2016-05-02",
          reportid: "555xxx",
          shop_name: "上海市普陀区金沙江路 1518 弄",
          platform_code: "JD",
          reporturl: "http://xxx",
          status: 5
        }
      ],
      logintype: getLoginType(),
      pagination: {
        size: 10,
        current: 1
      },
      pagesizes: [10, 20, 30, 40],
      chekTableNum: {
        all: "",
        check: 0
      }
    };
  },
  components: { tableHeader, Pagination, rightInfo },
  methods: {
    toggleSelection() {},
    selectionChange() {},
    handleCurrentChange() {},
    handleSizeChange() {},
    changePage() {
      console.log(this.pagination);
    },
    tableRowClick() {
      this.$refs.showInfo.drawer = true;
    }
  }
};
</script>